<div class="task-page">
    <mat-accordion>
        <mat-expansion-panel *ngFor="let task of tasks; index as i;"
        (opened)="DefaultValue(i, task)"
        >
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{task.name}}
                </mat-panel-title>
                <mat-panel-description >
                </mat-panel-description>
            </mat-expansion-panel-header>
            <form action="" [formGroup]="taskForm">
                <mat-form-field class="full-width">
                    <mat-label>Название урока</mat-label>
                    <input formControlName="name" matInput name="name" placeholder="Ex. Учимся Select" value="{{task.name}}">
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>Теория</mat-label>
                    <textarea formControlName="information" rows="12" matInput name="information" placeholder="Ex. Чтобы делать select надо...">{{task.theory}}</textarea>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>Модуль ответа</mat-label>
                    <mat-select (selectionChange)="changeModule()" [(value)]="answerModule">
                        <mat-option value="form">Form</mat-option>
                        <mat-option value="code">Code</mat-option>
                    </mat-select>
                </mat-form-field>
                <div *ngIf="answerModule == 'form'">
                    <fields-widget [formFields]="formFields" [parentId]="task.id" [module]="'task'" (NewSchema)="getNewSchema($event)"></fields-widget>
                </div>
                <div *ngIf="answerModule == 'code'">
                    <mat-form-field class="full-width">
                        <mat-label>Технология обработки</mat-label>
                        <input matInput  formControlName="technology" placeholder="Технология" value="">
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-label>Стиль синтаксиса</mat-label>
                        <input matInput  formControlName="notepadmode" placeholder="Notepadmode" value="">
                    </mat-form-field>
                    <mat-form-field class="full-width">
                        <mat-label>Тип ответа</mat-label>
                        <mat-select  formControlName="resulttype">
                            <mat-option  value="1">Ответ строкой</mat-option>
                            <mat-option  value="0">Ответ таблицей</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <br>
                <button (click)="editTask(task.id, i)" mat-raised-button>Save</button>
                <button (click)="deleteTask(task.id, i)" mat-raised-button color="warn">Delete</button>
            </form>
        </mat-expansion-panel>
        <mat-expansion-panel   (opened)="taskForm.reset()"
        >
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <button mat-mini-fab color="primary" aria-label="Example icon button with a home icon">
                        <mat-icon>add</mat-icon>
                    </button>
                </mat-panel-title>
                <mat-panel-description >
                </mat-panel-description>
            </mat-expansion-panel-header>
            <form action="" [formGroup]="taskForm">
                <mat-form-field class="full-width">
                    <mat-label>Название урока</mat-label>
                    <input formControlName="name" matInput name="name" placeholder="Ex. Учимся Select" value="">
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>Теория</mat-label>
                    <textarea formControlName="information" rows="12" matInput name="information" placeholder="Ex. Чтобы делать select надо..."></textarea>
                </mat-form-field>
                <mat-form-field class="full-width">
                    <mat-label>Модуль ответа</mat-label>
                    <mat-select  formControlName="technology">
                        <mat-option  value="form">Форма</mat-option>
                        <mat-option  value="go">Code</mat-option>
                    </mat-select>
                </mat-form-field>
                <button (click)="addTask(lesson_id)" mat-raised-button color="primary">add</button>
            </form>
        </mat-expansion-panel>
    </mat-accordion>
    <div class="task-view" *ngIf="currentTask !== '-1'">
        <div *ngIf="tasks[currentTask]">
            <ng-container *ngIf="tasks[currentTask].technology == 'form'; then formView; else codeView"></ng-container>
            <ng-template #formView>
                <sf-form (onChange)="schemaModel=$event.value" *ngIf="mySchema !== null" [schema]="mySchema">
                </sf-form>
                <p class="answer" *ngIf="checkAnswer !== ''">{{checkAnswer}}</p>
                <button (click)="UpdateAnswer()" mat-raised-button>Cохранить правильные ответы</button>
            </ng-template>
            <ng-template #codeView>
                <ngx-codemirror [formControl]="query" 
                [options]="{
                    lineNumbers: true,
                    theme: 'eclipse',
                    mode: tasks[currentTask].notepadmode
                }"></ngx-codemirror>
                <button (click)="run(currentTaskId)" mat-raised-button>Выполнить</button>
                <button (click)="updateHash(currentTaskId)" *ngIf="responseCheck" color="primary" mat-raised-button>Сохранить верный результат</button>
                <p class="answer" *ngIf="checkAnswer !== ''">{{checkAnswer}}</p>
                <div *ngIf="responseCheck">
                    <ng-container *ngIf="tasks[currentTask].resulttype == 0; then tableanswer else stringanswer" ></ng-container>
                </div>
                <!--Ответ таблицей-->
                <ng-template #tableanswer>
                    <ng-container *ngIf="responseCheck.resultcontent;">
                        <table mat-table [dataSource]="responseCheck.resultcontent.tablerows" class="mat-elevation-z8">
                            <ng-container *ngFor="let column of responseCheck.resultcontent.tableheaders;">
                                <ng-container  matColumnDef="{{column}}">
                                    <th mat-header-cell *matHeaderCellDef> {{column | uppercase}} </th>
                                <td mat-cell *matCellDef="let row"> {{row[column]}} </td>
                                </ng-container>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="responseCheck.resultcontent.tableheaders"></tr>
                            <tr mat-row *matRowDef="let row; columns: responseCheck.resultcontent.tableheaders;"></tr>
                        </table>
                    </ng-container>
                </ng-template>

                    <!--Ответ строкой-->
                <ng-template #stringanswer>
                    <ng-container *ngIf="responseCheck.resultcontent;">
                        <span style="white-space: pre-line">{{responseCheck.resultcontent.text}}</span>
                    </ng-container>
                </ng-template>
            </ng-template>
        </div>
    </div>
</div>